/* Hebrew presentation only. Does not alter form submission or consent. */
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('he')) return;
  const css = `
    :host { direction: rtl; }
    [role="dialog"] { direction: rtl; text-align: right; }
    form input:not([type="checkbox"]):not([type="radio"]),
    form textarea, form select { text-align: right !important; font-size: 16px; }
    input#first_name, input#last_name, textarea { direction: rtl !important; }
    input#email, input[type="email"], input[type="tel"] { direction: ltr !important; text-align: right !important; }
    label[for="first_name"], label[for="last_name"], label[for="email"], label[for="phone_number"] {
      left: auto !important; right: var(--form-field-padding, 15px) !important;
      text-align: right !important; direction: rtl; max-width: calc(100% - 30px);
    }
    form label { text-align: right; }
    [role="dialog"] h1, [role="dialog"] h2, [role="dialog"] p { text-align: right; }
  `;
  const handled = new WeakSet();
  const install = (host) => {
    const root = host.shadowRoot;
    if (!root || handled.has(root)) return;
    handled.add(root);
    const ensure = () => {
      if (root.getElementById('so-forms-hebrew')) return;
      const style = document.createElement('style');
      style.id = 'so-forms-hebrew';
      style.textContent = css;
      root.appendChild(style);
    };
    ensure();
    new MutationObserver(ensure).observe(root, {childList: true});
  };
  const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(install);
  scan();
  let tries = 0;
  const timer = setInterval(() => { scan(); if (++tries >= 60) clearInterval(timer); }, 500);
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('shopify-forms-embed') || n.querySelector('shopify-forms-embed'))))) scan();
  }).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', scan);
})();